import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HandHeart, Loader2, LockKeyhole, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiError } from "@/lib/api";
import { volApi, VOLUNTEER_TOKEN_KEY } from "@/lib/volunteerApi";

export default function VolunteerSignin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const signIn = async () => {
    setBusy(true);
    try {
      const res = await volApi.post("/volunteer/login", form);
      localStorage.setItem(VOLUNTEER_TOKEN_KEY, res.data.access_token);
      navigate("/volunteer", { replace: true });
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  return (
    <div className="grid min-h-screen place-items-center bg-background px-4 py-10">
      <div className="panel w-full max-w-sm p-7" data-testid="volunteer-signin-card">
        <div className="flex items-center gap-2.5">
          <span className="grid h-9 w-9 place-items-center rounded-[10px] bg-gradient-to-br from-primary to-[hsl(var(--teal))]">
            <HandHeart className="h-4 w-4 text-white" />
          </span>
          <div>
            <div className="text-[10px] uppercase tracking-[1.6px] text-muted-foreground">
              Volunteer account
            </div>
            <div className="font-display text-[17px] font-bold text-foreground">Sign in</div>
          </div>
        </div>

        <div className="mt-5 space-y-3">
          <div className="space-y-1.5">
            <Label className="text-[11px] text-muted-foreground">Email address</Label>
            <Input value={form.email} data-testid="volunteer-email-input" autoComplete="username"
                   onChange={(e) => setForm({ ...form, email: e.target.value })}
                   className="bg-muted/40 font-mono text-[12.5px]" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[11px] text-muted-foreground">Password</Label>
            <Input type="password" value={form.password} data-testid="volunteer-password-input"
                   autoComplete="current-password"
                   onKeyDown={(e) => e.key === "Enter" && signIn()}
                   onChange={(e) => setForm({ ...form, password: e.target.value })}
                   className="bg-muted/40" />
          </div>
          <Button onClick={signIn} data-testid="volunteer-signin-button"
                  disabled={busy || !form.email || !form.password}
                  className="w-full rounded-full bg-primary text-primary-foreground hover:bg-primary/90">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              : <LockKeyhole className="mr-2 h-4 w-4" />} Sign in
          </Button>
        </div>

        <p className="mt-5 flex items-center gap-1.5 text-[10.5px] text-muted-foreground">
          <ShieldCheck className="h-3 w-3" /> Your account is created from the invitation our team
          sends you.
        </p>
      </div>
    </div>
  );
}
